import { Html, Head, Body, Container, Section, Heading, Text } from '@react-email/components';
import { EmailHeader, EmailFooter } from './components';

interface CollectionRequestProps {
  contactName: string;
  companyName: string;
  period: string;
  reminderCount: number; // 0 = initial, 1-3 = reminders
  metricsList: string[];
}

export const CollectionRequest = ({ contactName, companyName, period, reminderCount, metricsList }: CollectionRequestProps) => {
  const isReminder = reminderCount > 0;
  const tone = reminderCount === 0 ? 'initial' : reminderCount <= 2 ? 'gentle' : 'urgent';

  return (
    <Html>
      <Head />
      <Body
        style={{
          backgroundColor: '#F9FAFB',
          fontFamily: "'Figtree', Arial, sans-serif",
          padding: '32px 0',
        }}
      >
        <Container
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 2px 6px rgba(15,23,42,0.08)',
            padding: '32px',
            maxWidth: '600px',
          }}
        >
          <EmailHeader />

          {isReminder && tone === 'urgent' && (
            <Section
              style={{
                backgroundColor: '#FEF3C7',
                border: '1px solid #F59E0B',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
              }}
            >
              <Text style={{ margin: '0', color: '#92400E', fontSize: '14px', fontWeight: '600' }}>⚠️ Final Reminder</Text>
            </Section>
          )}

          <Heading
            style={{
              fontSize: '24px',
              lineHeight: '1.3',
              color: '#174a43',
              margin: '0 0 16px',
            }}
          >
            {isReminder ? `Reminder ${reminderCount}: ` : ''}
            {period} Metrics Request — {companyName}
          </Heading>

          <Text
            style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#111827',
              margin: '0 0 16px',
            }}
          >
            Hi {contactName},
          </Text>

          <Text
            style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#111827',
              margin: '0 0 16px',
            }}
          >
            {isReminder
              ? `This is reminder ${reminderCount} for your ${period} update for ${companyName}. Please reply with the metrics below or attach your report.`
              : `It's time for your ${period} update for ${companyName}. Reply with the metrics below or attach your usual report.`}
          </Text>

          <Section
            style={{
              backgroundColor: '#F9FAFB',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '24px',
            }}
          >
            <Text style={{ margin: '0 0 8px', fontWeight: '600', color: '#174a43' }}>Requested Metrics:</Text>
            {metricsList.map((metric, index) => (
              <Text key={index} style={{ margin: '4px 0', fontSize: '14px', color: '#111827' }}>
                • {metric}
              </Text>
            ))}
          </Section>

          <Text
            style={{
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#4B5563',
              margin: '0 0 32px',
            }}
          >
            Reply to this email with your data, and we'll confirm once everything is processed.
          </Text>

          <EmailFooter />
        </Container>
      </Body>
    </Html>
  );
};
